
import Vue, { PropType } from 'vue'
import { Connector, Project } from '../../../../../types/main'
import { ActivationToEdit } from '../../../../../types/GCB2'
import AudienceTitleWithParams from './AudienceTitleWithParams.vue'
import isEqual from 'lodash/isEqual'
import cloneDeep from 'lodash/cloneDeep'
export default Vue.extend({
    name: 'AudienceModal',
    components: {AudienceTitleWithParams},
    props: {
        value: { type: Boolean as PropType<boolean> },
        audienceFilterValues: { type: Object as PropType<any> },
        audience: { type: Object as PropType<any> },
        lists: { type: Object as PropType<any> },
        activationId: { type: Number as PropType<number> },
        currentActivation: { type: Object as PropType<ActivationToEdit> },
    },
    data: () => ({
        initAudienceFilterValues: null
    }),
    computed: {
        isDialog: {
            get(): boolean {
                return this.value
            },
            set(value: boolean): void {
                this.$emit('input', value)
            },
        },
        project(): Project {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        isDiff(): boolean {
            return !isEqual(this.audienceFilterValues, this.initAudienceFilterValues)
        }
    },
    watch: {
        isDialog(val) {
            if (val) {
                this.initData()
            }            
        },
    },
    methods: {
        initData() {
            this.initAudienceFilterValues = cloneDeep(this.audienceFilterValues)
        },
        closeModal() {
            this.isDialog = false
        },
        clearAndClose() {
            this.isDialog = false
            if(this.isDiff) {
                this.$emit('set-val', this.activationId, this.initAudienceFilterValues)
            }
        }
    },
})
